import { ModalBody as ChakraModalBody, ModalBodyProps as ChakraModalBodyProps } from '@chakra-ui/react';

const ModalBody = (props: ChakraModalBodyProps) => (
  // Workaround for styles not supported
  <ChakraModalBody {...props} />
);

export { ModalBody };
